import cloudServiceModule from '../cloudService.module';

class SsoApiService {
    constructor(__env, $http, $q) {
        this.__env = __env;
        this.$http = $http;
        this.$q = $q;
    }

    getServiceProviderMetadata(accountGuid) {
        const deferred = this.$q.defer();

        this.$http
            .get(
                `${
                    this.__env.cloudUrl
                }/sso/spmetadata/?accountGuid=${accountGuid}`
            )
            .then(
                response => deferred.resolve(response.data),
                response => deferred.reject(response.data)
            );

        return deferred.promise;
    }

    getSsoConfiguration(cloudToken) {
        const deferred = this.$q.defer();

        this.$http
            .get(`${this.__env.cloudApiUrl}/api/v2/sso/configuration`, {
                headers: {
                    token: cloudToken
                }
            })
            .then(
                response => deferred.resolve(response.data),
                response => deferred.reject(response.data)
            );

        return deferred.promise;
    }

    postSsoConfiguration(cloudToken, ssoConfiguration) {
        const deferred = this.$q.defer();

        this.$http
            .post(
                `${this.__env.cloudApiUrl}/api/v2/sso/configuration`,
                ssoConfiguration,
                {
                    headers: {
                        token: cloudToken
                    }
                }
            )
            .then(
                response => deferred.resolve(response.data),
                response => {
                    if (response.status == 400) {
                        let message = '';
                        if (
                            response.data &&
                            response.data.message != undefined
                        ) {
                            message = response.data.message;
                        }

                        deferred.reject({
                            invalidInput: true,
                            message: message
                        });

                        return;
                    }

                    deferred.reject(response.data);
                }
            );

        return deferred.promise;
    }
}

export default cloudServiceModule.service('ssoApiService', SsoApiService);



// WEBPACK FOOTER //
// ./modules/cloudService/sso/ssoApi.service.js